import React, { Component } from "react";
import requester from '../lib/requester'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
import logo from '../assets/img/logo.png'

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            loading: false,
            error: [],
            NewLogo: require('../assets/img/aam-new-logo-3.png')
        }
    }

    componentDidMount = () => {
        window.localStorage.removeItem('is_token')
        window.localStorage.removeItem('is_user')
        if (this.props.location.search === '?unauthorize') {
            let error = ['Unauthorized, please login']
            this.setState({ error: error }) 
        }
    }

    handleLogin = (e) => {
        e.preventDefault()
        this.setState({ loading: true })
        let error = []
        if (this.state.username.length === 0) {
            error.push('Username can\'t be blank')
        }
        if (this.state.password.length === 0) {
            error.push('Password can\'t be blank')
        }
        if (error.length === 0) {
            let url = '/arman/v1/auth/login'
            let param = { username: this.state.username, password: this.state.password }
            requester.postArman(url, param, {
                success: function (response) {
                    let { access_token, user, principal_group, branch, sso_token } = response.data.data
                    if (access_token) {
                        let data = {
                            realname: user.realname,
                            username: user.username,
                            org_name: user.org_name,
                            org_type: user.org_type,
                            role_name: user.role_name,
                            user_id: user.user_id,
                            org_id: user.org_id,
                            org_initial: user.org_initial,
                            origin: user.origin,
                            principal_group: principal_group,
                            branch: branch,
                            sso_token: sso_token
                        }
                        window.localStorage.setItem('is_token', access_token)
                        window.localStorage.setItem('is_user', JSON.stringify(data))
                        this.setState({ loading: false })
                        window.location.href = '/admin/dashboard'
                    } else {
                        let error = ['Failed to login, please try again']
                        this.setState({ error: error, loading: false })
                    }
                }.bind(this),
                error: function (e) {
                    let error = e.response && e.response.data.message.length > 0 ? e.response.data.message[0].desc : 'Failed to login, please try again'
                    this.setState({ error: [error], loading: false })
                }.bind(this)
            })
        } else {
            this.setState({ error: error, loading: false })
            return false
        }
    }

    handleInputUsername = (e) => {
        this.setState({ username: e.target.value })
    }

    handleInputPassword = (e) => {
        this.setState({ password: e.target.value })
    }

    showError = () => {
        if (this.state.error.length > 0) {
            return (
                <div className="alert alert-danger" role="alert">
                    <ul>
                        {this.state.error.map((item, index) => {
                            return (<li key={index}>{item}</li>)
                        })}
                    </ul>
                </div>
            )
        }
    }

    render() {
        return (
            <div className="container-fluid container-login100 bg">
                <div className="row h-100 justify-content-center align-items-center">
                    <div className="col-md-4 col-lg-4 col-sm-12 mx-auto mt-5">
                        <div className="card custom-card">
                            <div className="card-body p-5 montserrat">
                                {this.showError()}
                                <div className="row">
                                    <div className="mx-auto">
                                        <img src={logo} className="fullwidth" />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-md-12 text-center text-secondary">Sign in to start your session</div>
                                </div>
                                <form onSubmit={this.handleLogin.bind(this)}>
                                    <div className="form-group">
                                        <label className="text-dark">Email</label>
                                        <span className="icon-span">
                                            <i className="fas fa-user text-secondary"></i>
                                        </span>
                                        <input type="text" className="form-control icon-input" id="formGroupExampleInput" autoComplete="off" placeholder="Type Your Email" onChange={this.handleInputUsername.bind(this)} />
                                    </div>
                                    <div className="form-group">
                                        <label className="text-dark">Password</label>
                                        <span className="icon-span">
                                            <i className="fas fa-unlock text-secondary"></i>
                                        </span>
                                        <input type="password" className="form-control icon-input" id="formGroupExampleInput2" placeholder="Type Your Password" onChange={this.handleInputPassword.bind(this)} />
                                    </div>
                                    <button type="submit" className="btn btn-primary btn-block login100-form-btn mt-4" onClick={() => { this.handleLogin.bind(this) }}>LOGIN</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Loader fullPage loading={this.state.loading} />
            </div>
        )
    }
}

export default Login
